/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExternalEmrDocumentPullStart } from './ExternalEmrDocumentPullStart';
import {
    ExternalEmrDocumentPullStartFromJSON,
    ExternalEmrDocumentPullStartFromJSONTyped,
    ExternalEmrDocumentPullStartToJSON,
} from './ExternalEmrDocumentPullStart';

/**
 * 
 * @export
 * @interface StartExternalEmrDocumentPull201Response
 */
export interface StartExternalEmrDocumentPull201Response {
    /**
     * 
     * @type {ExternalEmrDocumentPullStart}
     * @memberof StartExternalEmrDocumentPull201Response
     */
    data?: ExternalEmrDocumentPullStart;
}

/**
 * Check if a given object implements the StartExternalEmrDocumentPull201Response interface.
 */
export function instanceOfStartExternalEmrDocumentPull201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StartExternalEmrDocumentPull201ResponseFromJSON(json: any): StartExternalEmrDocumentPull201Response {
    return StartExternalEmrDocumentPull201ResponseFromJSONTyped(json, false);
}

export function StartExternalEmrDocumentPull201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartExternalEmrDocumentPull201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ExternalEmrDocumentPullStartFromJSON(json['data']),
    };
}

export function StartExternalEmrDocumentPull201ResponseToJSON(value?: StartExternalEmrDocumentPull201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ExternalEmrDocumentPullStartToJSON(value.data),
    };
}

